var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-main"
  }, [_c('div', {
    staticClass: "video__bear error404__bear",
    attrs: {
      "id": "bear"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "error404"
  }, [_c('h1', {
    staticClass: "error404__title"
  }, [_c('span', {
    staticClass: "error404__color"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "error404__color2"
  }, [_vm._v("0")]), _vm._v(" "), _c('span', {
    staticClass: "error404__color3"
  }, [_vm._v("4")])]), _vm._v(" "), _c('h3', {
    staticClass: "error404__message"
  }, [_vm._v("Мечето не е намерено...")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d1090c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error404.vue
// module id = WY3w
// module chunks = 1